import React, {Component} from "react";
import {connect} from "react-redux";
import UserHeader from "./UserHeader";
import Xhr from "../../helpers/Xhr";
import Loading from "../../components/Loading";
import {Redirect} from "react-router-dom";

class UserPassport extends Component {
	state = {
		images   : [],
		files    : {},
		messages : [],
		status   : '',
		loading  : false
	};

	addImages(e) {
		const targetFiles = e.target.files;

		Object.values(targetFiles).forEach((file, i) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);

			const {images, files} = this.state;

			const count = Object.keys(files).length;
			reader.onloadend = ((event) => this.setState({
				images : [...images, event.target.result],
				files  : {...files, [count] : file}
			}));
		});

	}

	removeItem(index) {
		const {images, files} = this.state;
		images.splice(index, 1);

		delete files[index];

		this.setState({
			images : images,
			files  : files
		});
	}

	loadPassport(e) {
		e.preventDefault();

		const fd = new FormData();
		const {files} = this.state;

		Object.values(files).forEach((file, i) => {
			fd.append(`photo${i}`, file);
		});

		this.setState({loading : true});

		Xhr.loadPassport(fd).then((resp) => {
			this.setState({
				messages : resp.data.messages,
				status   : resp.status,
				loading  : false
			});
		});
	}

	render() {
		const {user} = this.props;
		const info = user.info;

		if (info.passport.length > 0) {
			return <Redirect to={'/'} />
		}

		const {images, files} = this.state;

		return (
			<div>
				<UserHeader text={'Загрузка документа, удостоверяющего личность'}/>

				<form id="userdata_form" method="post" action="">
					<div className="userdata">
						<label className="userdata__passport__select" htmlFor="files">
							<i className="fas fa-upload"></i>
						</label>

						<input type="file"
						       multiple="multiple"
						       id="files"
						       onChange={(e) => this.addImages(e)}/>

						<ul className="userdata__passport">
							{images.map((image, index) => {
								return (
									<li key={index} className="userdata__passport-image" style={{backgroundImage : `url('${image}')`}}>
										<div className="remove" onClick={this.removeItem.bind(this, index)}>
											<i className="fas fa-times"></i></div>
									</li>
								);
							})}
						</ul>
					</div>
					<div className="userdata" style={{flexDirection : 'column'}}>
						<div className="buttons">
							<button className="buttons__show" onClick={this.loadPassport.bind(this)}>загрузить</button>
						</div>
						{this.state.loading && <Loading/>}
						<div className={`messages ${this.state.status}`} style={{textAlign : 'center', marginTop : 10}}>
							{this.state.messages.join('; ')}
						</div>
					</div>
				</form>
			</div>
		);
	}
}

export default connect(
	state => ({
		user : state.user
	}),
	dispatch => ({})
)(UserPassport);


// WEBPACK FOOTER //
// ./src/app/pages/User/UserPassport.js